module.exports = __webpack_public_path__ + "img/development-concept.a3f8220a.jpg";